/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_ConfirmInputs */

const cs_client_merge_confirm = /** @type {(inputs: Client_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučit a smazat zdroj?`)
};

const en_client_merge_confirm = /** @type {(inputs: Client_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge and delete the source?`)
};

/**
* | output |
* | --- |
* | "Merge and delete the source?" |
*
* @param {Client_Merge_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_confirm = /** @type {((inputs?: Client_Merge_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_confirm(inputs)
	return cs_client_merge_confirm(inputs)
});